import { Injectable } from '@angular/core';
import { DocumentRequestBatchesDataService } from '@wtax/data-angular';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GeneratedFilesResponse } from '../models/document-request-batch.models';

@Injectable({
  providedIn: 'root',
})
export class DocumentRequestBatchService {
  constructor(private readonly documentRequestBatchesDataService: DocumentRequestBatchesDataService) {}

  public getGeneratedFilesZip$(batchId: string): Observable<GeneratedFilesResponse> {
    return this.toGeneratedFilesResponse$(
      this.documentRequestBatchesDataService.createDocumentRequestBatchFilesArchive(batchId, 'response', false, {
        httpHeaderAccept: 'application/zip' as any,
      })
    );
  }

  public getClientGeneratedFilesZip$(): Observable<GeneratedFilesResponse> {
    return this.toGeneratedFilesResponse$(
      this.documentRequestBatchesDataService.createClientGeneratedFilesArchive('response', false, {
        httpHeaderAccept: 'application/zip' as any,
      })
    );
  }

  private toGeneratedFilesResponse$(source$: Observable<any>): Observable<GeneratedFilesResponse> {
    return source$.pipe(
      switchMap(async (response: any) => {
        let data: any = response;

        // If response is an HTTP response object, get the body
        if (response && typeof response === 'object' && 'body' in response) {
          data = response.body;

          // If body is a Blob, read it as text and parse as JSON
          if (data instanceof Blob) {
            const text = await data.text();
            data = JSON.parse(text);
          }
        }

        // Extract the file URL and name from the response
        const archive_file_url = data?.archive_file_url || data?.archiveFileUrl || '';
        const file_name = data?.file_name || data?.fileName || '';

        return {
          archive_file_url,
          file_name,
        };
      })
    );
  }
}
